<template>
  <canvas ref="preview" :width="width" :height="height"></canvas>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      ctx: null,
      collection: [],
      loaded: false,
      imagesLoaded: 0,
    };
  },
  mounted() {
    this.ctx = this.$refs.preview.getContext('2d');
    this.preload();
  },
  methods: {
    preload() {
      this.imagesLoaded = 0;
      this.collection = [];

      for (let i = 0; i < this.images.length; i += 1) {
        this.collection[i] = new Image();
        this.collection[i].addEventListener('load', this.handleImageLoaded);
        this.collection[i].src = `/static/images/parts/${this.images[i].image}`;
      }
    },
    handleImageLoaded() {
      this.imagesLoaded += 1;

      if (this.imagesLoaded === this.images.length) {
        this.loaded = true;
        this.render();
      }
    },
    calculateOffsets() {
      if (this.images.length === 0) return [0];

      const offsets = [this.images[0].corners.TL[0]];

      for (let i = 0; i < this.images.length; i += 1) {
        const realWidth = this.images[i].corners.TR[0] - this.images[i].corners.TL[0];
        offsets.push(offsets[i] + realWidth);
      }

      return offsets;
    },
    render() {
      this.ctx.clearRect(0, 0, this.width, this.height);

      const offsets = this.calculateOffsets();
      const startX = (this.width - offsets[offsets.length - 1]) / 2;

      for (let i = this.images.length - 1; i >= 0; i -= 1) {
        this.ctx.drawImage(this.collection[i],
          startX + (offsets[i] - this.images[i].corners.TL[0]),
          100,
          this.images[i].width,
          this.images[i].height);
      }
    },
  },
  computed: {
    ...mapState(['images']),
    width() { return 6400 * 0.96; },
    height() { return 2790 * 0.96; },
  },
  watch: {
    images() {
      this.preload();
    },
  },
};
</script>

<style lang="scss">
canvas {
  width: 100%;
  height: auto;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
</style>




// WEBPACK FOOTER //
// src/components/Preview.vue